/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    VoucherCategory,
    VoucherCategoryFromJSON,
    VoucherCategoryToJSON,
    VoucherCategoryDataFrame,
    VoucherCategoryDataFrameFromJSON,
    VoucherCategoryDataFrameToJSON,
} from '../models';

export interface ApiVoucherCategoriesGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiVoucherCategoriesIdDeleteRequest {
    id: number;
}

export interface ApiVoucherCategoriesIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiVoucherCategoriesPostRequest {
    relations?: string;
    deleted?: boolean;
    voucherCategory?: VoucherCategory;
}

/**
 * no description
 */
export class VoucherCategoryApi extends runtime.BaseAPI {

    /**
     * Get list of VoucherCategory
     */
    async apiVoucherCategoriesGetRaw(requestParameters: ApiVoucherCategoriesGetRequest): Promise<runtime.ApiResponse<VoucherCategoryDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/voucherCategories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherCategoryDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of VoucherCategory
     */
    async apiVoucherCategoriesGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<VoucherCategoryDataFrame> {
        const response = await this.apiVoucherCategoriesGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of VoucherCategory
     */
    async apiVoucherCategoriesIdDeleteRaw(requestParameters: ApiVoucherCategoriesIdDeleteRequest): Promise<runtime.ApiResponse<VoucherCategory>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiVoucherCategoriesIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherCategories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherCategoryFromJSON(jsonValue));
    }

    /**
     * Remove entity of VoucherCategory
     */
    async apiVoucherCategoriesIdDelete(id: number): Promise<VoucherCategory> {
        const response = await this.apiVoucherCategoriesIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of VoucherCategory
     */
    async apiVoucherCategoriesIdGetRaw(requestParameters: ApiVoucherCategoriesIdGetRequest): Promise<runtime.ApiResponse<VoucherCategory>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiVoucherCategoriesIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/voucherCategories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherCategoryFromJSON(jsonValue));
    }

    /**
     * Get entity of VoucherCategory
     */
    async apiVoucherCategoriesIdGet(id: number, relations?: string, deleted?: boolean): Promise<VoucherCategory> {
        const response = await this.apiVoucherCategoriesIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of VoucherCategory (if id defined)
     */
    async apiVoucherCategoriesPostRaw(requestParameters: ApiVoucherCategoriesPostRequest): Promise<runtime.ApiResponse<VoucherCategory>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/voucherCategories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VoucherCategoryToJSON(requestParameters.voucherCategory),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => VoucherCategoryFromJSON(jsonValue));
    }

    /**
     * Create or update entity of VoucherCategory (if id defined)
     */
    async apiVoucherCategoriesPost(relations?: string, deleted?: boolean, voucherCategory?: VoucherCategory): Promise<VoucherCategory> {
        const response = await this.apiVoucherCategoriesPostRaw({ relations: relations, deleted: deleted, voucherCategory: voucherCategory });
        return await response.value();
    }

}
